import type { GuideWalkthroughDef } from "../types";
import { explainListStep } from "./steps/shared";

/**
 * The comprehensive list tour: jump to a date → create an order → open the
 * conversation behind one → understand the status tabs → the "À traiter" tab →
 * narrow with search → read the day total. Every step is an EXPLAIN step
 * (spotlight + read + "Suivant"/"Terminé"); the user may operate any highlighted
 * control first, but reading is the whole step, so none advances on a real
 * action.
 */
export const positionsTour: GuideWalkthroughDef = {
  id: "positions-tour",
  titleKey: "guide.walkthroughs.positionsTour.title",
  entry: {
    target: "sidebar-link-recap",
    bodyKey: "guide.walkthroughs.positionsTour.entryBody",
  },
  steps: [
    // The header date control — which day/period the list shows.
    explainListStep(
      "recap-date-popover-trigger",
      "guide.walkthroughs.positionsTour.dateBody",
    ),
    // The manual create control — start a new transport order by hand.
    explainListStep(
      "recap-new-order-select",
      "guide.walkthroughs.positionsTour.createOrderBody",
    ),
    // The conversation behind an order — read where the source lives.
    explainListStep(
      "recap-show-chats-button",
      "guide.walkthroughs.positionsTour.conversationBody",
    ),
    // The whole status-tab row — filtering orders by status.
    explainListStep(
      "recap-view-tabs-group",
      "guide.walkthroughs.positionsTour.statusTabsBody",
    ),
    // The "À traiter" tab specifically — what needs attention + row colours.
    explainListStep(
      "recap-view-tab-to_process",
      "guide.walkthroughs.positionsTour.toProcessTabBody",
    ),
    // The search box — name what it filters by.
    explainListStep(
      "recap-search-input",
      "guide.walkthroughs.positionsTour.narrowBody",
    ),
    // The column-header row — every column filters from its own header.
    explainListStep(
      "pre-order-list-header",
      "guide.walkthroughs.positionsTour.filtersRowBody",
    ),
    // The employee column filter — narrow the list to your own orders.
    explainListStep(
      "pre-order-list-header-employee",
      "guide.walkthroughs.positionsTour.employeeFilterBody",
    ),
    // The Filters (Affichage) button — where the deleted-orders view lives.
    explainListStep(
      "recap-filter-button",
      "guide.walkthroughs.positionsTour.filtersButtonBody",
    ),
    // The day-total block (a read-only summary, nothing to click).
    explainListStep(
      "recap-day-total",
      "guide.walkthroughs.positionsTour.dayBody",
    ),
  ],
};
